import React from 'react';
import UtilityButton from '../../buttons/utilityButton';

const ProposalCardLoader = () => {
  return (
    <section
      className={`flex flex-col justify-between col-span-12 md:col-span-6 lg:col-span-4 grid grid-cols-12  gap-4 mt-4 h-auto bg-black-30/60 rounded animate-pulse`}
    >
      <div className="col-span-12">
        <div className="flex flex-col justify-start">
          <div className="px-0 w-full aspect-4/3 relative">
            <div className="bg-black-30/80 rounded w-full h-full aspect-4/3"></div>
            <div className="absolute top-0 left-0 flex bg-black-40 p-2 text-white rounded m-2">
              <span className="relative w-8 h-4">&nbsp;</span>
            </div>
            <div className="absolute bottom-0 flex bg-white/60 opacity-50 rounded-lg m-2">
              <div
                className={`flex items-center flex-nowrap  rounded-l-lg pl-2 mr-[1px]`}
              >
                <div
                  className={`flex flex-nowrap items-center w-auto py-2 pr-2 `}
                >
                  <div className="w-5 h-5 bg-black/40 rounded"></div>
                </div>
                <span className="text-xs pr-2">&nbsp;</span>
              </div>
              <div className={`flex items-center flex-nowrap  pl-2 mr-[1px]`}>
                <div
                  className={`flex flex-nowrap items-center w-auto py-2 pr-2 `}
                >
                  <div className="w-5 h-5 bg-black/40 rounded"></div>
                </div>
                <span className="text-xs pr-2">&nbsp;</span>
              </div>
              <div
                className={`flex items-center flex-nowrap  rounded-r-lg pl-2`}
              >
                <div
                  className={`flex flex-nowrap items-center w-auto py-2 pr-2 `}
                >
                  <div className="w-5 h-5 bg-black/40 rounded"></div>
                </div>
                <span className="text-xxs pr-4">&nbsp;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-span-12 grid-cols-12">
        <div className="col-span-12">
          <div className="py-0 px-4">
            <h2 className="w-3/4 h-6 bg-black/50 rounded">{'    '}</h2>
            <div className="w-28 h-4 bg-black/40 rounded my-2">
              <span>
                {'   '}
                <br />
              </span>{' '}
            </div>
            <div className="w-24 h-4 bg-black/40 rounded my-2">
              <span>{'   '}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-span-12 rounded-b md:rounded-r">
        <div className="px-4 pt-4">
          <span className="text-xxs py-2">{'   '}</span>
          <div className="-mx-1">
            <UtilityButton
              label={<div className="w-48 rounded h-6"></div>}
              onClick={() => {}}
              enabled={false}
              width="w-max"
              color={'gray'}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProposalCardLoader;
